import React, {  Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';

/*Actions*/
import {
	addToCart,
	saveToCart,
	getOrderDetailsList,
	saveOrderDetailsList,
	checkServicesPricesForCartPage,
	getSearchKeywordSuggestionList,
	ajaxRequestInitiated,
	ajaxRequestCompleted,
	saveAvailabilityToCart
} from '../../../redux/actions';
import { checkForTokenAccountByMasterSA } from '../../../redux/util';

import { DATE_TIME_FORMAT } from '../../common/messageConstants';

class AddToCart extends Component {

	constructor(props) {
        super(props);
        this.state = {
            isSpecpage: false
        };
		this.makeServiceCallAddtoCart = this.makeServiceCallAddtoCart.bind(this);
		this.afterCart = this.afterCart.bind(this);
		this.getDemadClassforAgreement = this.getDemadClassforAgreement.bind(this);
    }

    componentDidMount(){
        this.setState({
			isSpecpage: window.location.href.indexOf("product-specs") > -1
		});
    }

	getParentItem(item, allItems) {
		let parentItem = null;
		if (item.itemType === 'S') {
			const parentItemData = allItems.filter((itm) => parseInt(itm.lineNo) < parseInt(item.lineNo) && itm.itemType === 'M');
			
			if(item.originalItem !== null){
                parentItem = item.originalItem;
            }
            else if (item.originalItem === null && parentItemData && parentItemData.length > 0) {
                parentItem = parentItemData[parentItemData.length-1].item;    
            }
		}
		return parentItem;
	}

	isMService(itemName) {
		let flag = false;
		if (itemName.length === 4 && itemName.indexOf("M") === 0) {
			flag = true;
		}
		return flag;
	}

    handleAddToCart(product, productDescription, itemType, event) {
		event.preventDefault();
		const self = this,
			{ selectedAccount, selectedPriceSource } = self.props.state.user,
			{ cart } = self.props.state.cart,
			cartItems = cart && cart.responseObject && cart.responseObject.cartItems ? cart.responseObject.cartItems : [];
			let productState = self.props.state.product;

			let searchKeywordState = self.props.state.searchKeyword;
			let filteredProduct =[];

			if(self.props.searchSuggestions === undefined){
				if(productState && productState.productResultAvailability && productState.productResultAvailability.length >0){ 
					//To prepare a product list that includes the replacementList items.
					let productsIncludingReplacedSku =  _.flatMap(productState.productResultAvailability,(skuItem)=>{
					if(skuItem.replacementList){
						return [skuItem,...skuItem.replacementList]
					}else {
						return [skuItem]
					}
					});
					
				 filteredProduct= productsIncludingReplacedSku.filter((item)=>{
					return item.sku == product
					});
				}
			}

			if(self.props.searchSuggestions === `searchSuggestions`){
				filteredProduct= searchKeywordState && searchKeywordState.productNumberList && searchKeywordState.productNumberList.length > 0 && searchKeywordState.productNumberList.filter((item)=>{
					return item.sku == product
				})
			}

		if(self.props.isPackage) {
			const { orderDetails } = self.props;
			if (!orderDetails) {
				// get packges details
				self.props.getOrderDetailsList(`orderNumber=${self.props.orderNumber}&requestType=getOrderDetails&accountNumber=${selectedAccount.ACCOUNTNUMBER}`, (response) => {
					if(!response.status) { // if data is not found
						self.props.saveOrderDetailsList(null);
					} else {
						self.props.getItemTypeByOrderDetails(response.responseObject, resp => {
							if(!resp.status) {
								self.setState({
									errorMessage: response.responseMessage
								})
							} else {
								const orderDetails = resp.orderDetails;
								let keys=[];
								let count= 0;
								 self.props.ajaxRequestInitiated();
								 orderDetails.items.forEach( (item,index) => {
									const createdDate = moment().add(index,'seconds').format(DATE_TIME_FORMAT);
									keys.push(item.item);								
									if(self.isMService(item.item)){
										cartItems.push ({
											itemType: item.itemType,
											item: item.item,
											quantity: "1",
											itemDescription: item.itemDescription,
										 packageName: self.props.packageName,
										 parentItem: self.getParentItem(item, resp.orderDetails.items),
										 agreementNumber: item.agreementNumber,
										 createdDate:createdDate ,
										 updatedDate: moment().format(DATE_TIME_FORMAT),
										 imagePath: item.imagePath,
										 overpackQuantityRequired: item.overpackQuantityRequired,
										 packageQuantity:item.packageQuantity
										});
										count++
										if(count === orderDetails.items.length){ 
											self.props.ajaxRequestCompleted();
											self.makeServiceCallAddtoCart(cartItems,keys);
										};

									}else{
									  	self.props.getSearchKeywordSuggestionList(`requestType=getItems&keyword=${item.item}&count=5`, (response) => {
											item.imagePath = response.responseObject[0] && response.responseObject[0].imagePath;
											cartItems.push ({
												itemType: item.itemType,
												item: item.item,
												quantity: "1",
												itemDescription: item.itemDescription,
											 packageName: self.props.packageName,
											 parentItem: self.getParentItem(item, resp.orderDetails.items),
											 agreementNumber: item.agreementNumber,
											 createdDate: createdDate,
											 updatedDate: moment().format(DATE_TIME_FORMAT),
											 imagePath: item.imagePath,
											 overpackQuantityRequired: item.overpackQuantityRequired,
											 packageQuantity: item.packageQuantity
											});
											count++
											if(count === orderDetails.items.length) 
											{
												//To set the loader until the request is completed & then to make the add to cart service call.
												self.props.ajaxRequestCompleted();
												self.makeServiceCallAddtoCart(cartItems,keys);
											};
										});	
									}		                   
								});
							}
						});
					}
				});
			} else {
				orderDetails.items.forEach(item => {
					cartItems.push ({
						itemType: item.itemType,
						item: item.item,
						quantity: item.quantity,
						itemDescription: item.itemDescription,
						packageName: self.props.packageName,
						parentItem: self.getParentItem(item, orderDetails.items),
						agreementNumber: item.agreementNumber,
						createdDate: moment().format(DATE_TIME_FORMAT),
						updatedDate: moment().format(DATE_TIME_FORMAT),
						imagePath:orderDetails[item.item],
						overpackQuantityRequired:orderDetails[item.overpackQuantityRequired],
						packageQuantity: orderDetails[item.packageQuantity]
					});
					if (item.relatedServices && item.relatedServices.length > 0) {
						item.relatedServices.forEach(itm => {
							cartItems.push ({
								itemType: 'S',
								item: itm.serviceId,
								quantity: itm.quantity,
								itemDescription: itm.serviceName,
								packageName: self.props.packageName,
								parentItem: item.item,
								agreementNumber: item.agreementNumber,
								createdDate: moment().format(DATE_TIME_FORMAT),
								updatedDate: moment().format(DATE_TIME_FORMAT),
								imagePath:filteredProduct && filteredProduct.length>0 ? filteredProduct[0].imagePath:"",
								overpackQuantityRequired: filteredProduct && filteredProduct.length>0 ? filteredProduct[0].overpackQuantityRequired:"",
								packageQuantity: filteredProduct && filteredProduct.length>0 ? filteredProduct[0].packageQuantity:"",
							});
						});
					}
				});
				self.makeServiceCallAddtoCart(cartItems);
			}
		} else {
			cartItems.push({
	            itemType: !itemType || itemType === ''  ? "M" : itemType,
	            item: product,
	            quantity: "1",
	            itemDescription: productDescription,
				agreementNumber: selectedPriceSource.AGREEMENT_NUMBER,
				createdDate: moment().format(DATE_TIME_FORMAT),
				updatedDate: moment().format(DATE_TIME_FORMAT),
				imagePath:filteredProduct && filteredProduct.length>0 ? filteredProduct[0].imagePath:"",
				overpackQuantityRequired: filteredProduct && filteredProduct.length>0 ? filteredProduct[0].overpackQuantityRequired:"",
				packageQuantity: filteredProduct && filteredProduct.length>0 ? filteredProduct[0].packageQuantity:""
	        });
			self.makeServiceCallAddtoCart(cartItems);
		}
    }

	formatNumber2Decimal(number) {
		number = (number)?number.trim().replace(/,/g,""):number;
        if(number) {
			number = number.replace("$","");
			number = "$"+parseFloat(number).toFixed(2);
            return number === "$0.00"?"--":number;
        } else {
            return "--";
        }
    }

	makeServiceCallAddtoCart(cartItems,products=[]) {
		const self = this,
			{ selectedAccount, userDetails, selectedPriceSource } = self.props.state.user;
		let cartCount = 0;
		if (products.length>0){
			//Sort cartItems based on the products array
			cartItems.sort(function (a, b) {
				return products.indexOf(a.item) - products.indexOf(b.item);
			  });
		};

		cartItems.forEach(itm => {
			cartCount += parseInt(itm.quantity, 10);
		});
		// populate below undefined fields
		self.props.fireGTMTag('Add to Cart', {
			addToCartLocation: self.props.whichPage,
			cartQuantity: cartCount,
			ecommerce: {
				currencyCode: 'USD',
				add: {
					actionField: {
						list: self.props.whichPage === 'product list' ? self.props.list : undefined,
						position: self.props.whichPage === 'product list' ? self.props.position : undefined,
					},
					products: [{
						name: this.props.itemDescription,
						id: self.props.item,
						price: self.props.price && self.formatNumber2Decimal(self.props.price.toString()),
						brand: self.props.brand,
						category: self.props.category,
						variant: undefined,
						dimension70: 'no'
					}]
				}
			}
		});
		if((localStorage.getItem("punchOutAccess") == true || localStorage.getItem("punchOutAccess") == 'true')){
			cartItems.forEach(itm => {
				itm.agreementNumber = itm.agreementNumber.toString(); 
				itm.packageName = null;
				itm.quantity = parseInt(itm.quantity);
				itm.parentItem = null;
				itm.orderNumber = null;
				itm.orderLineId = null;
				itm.orderDate = null;
				itm.poNumber = null;
				itm.keepOriginalPrice = null;
				itm.keepOriginalPO = null;
				itm.buyerLineNo = null;
			  });
			this.afterCart({responseObject :{
				accountNumber: selectedAccount.ACCOUNTNUMBER,
				createdDate: moment().format('MM/DD/YYYY'),
				updatedDate: moment().format('MM/DD/YYYY'),
				userId: userDetails.sso,
				cartItems:cartItems
			},status : true}, self , selectedAccount, selectedPriceSource, cartItems);
		}
		else{
			self.props.addToCart({
				accountNumber: selectedAccount.ACCOUNTNUMBER,
				createdDate: moment().format('MM/DD/YYYY'),
				updatedDate: moment().format('MM/DD/YYYY'),
				userId: userDetails.sso,
				cartItems
			}, response => {
				this.afterCart(response, self , selectedAccount, selectedPriceSource, cartItems);
			});
		}
	}

	checkOrderAvailability(){
			const self = this;
			const {selectedADC } = this.props.state.user;
			const skuList = [];
			let data = JSON.parse(this.props.state.user.selectedAddress);
			let SITEUSEID = data ? data.SITE_USE_ID : '';
			let STATE = data? data.STATE:'';
			const cartItems = self.props.state.cart.cart;
			const { availability } = this.props.state.cart;
			const availabilityDataForAvailableBackorders = [];
			cartItems.responseObject && cartItems.responseObject.cartItems && cartItems.responseObject.cartItems.length > 0 && cartItems.responseObject.cartItems.forEach((item, index) => {
				const availabilityData = availability && _.find(availability, { sku: item.item });
				if ((item.itemType === 'M' || item.itemType === 'A') && !item.orderNumber) {
				skuList.push({
					itemNumber: item.item,
					identifier: index + 1,
					qty: item.quantity || 1,
					shipMethod: 'ADC Truckload',
					arrivalSetName: '',
					itemType: '',
					demandClass : self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1],
					overrideFlag: 'N',
					quantityUOM: 'EA',
					agreementNumber: item.agreementNumber,
				});
				} else if (item.orderNumber && availabilityData) {
					availabilityDataForAvailableBackorders.push(availabilityData);
				}
			});
			const payload = {
					accountNumber: this.props.state.user.selectedAccount.ACCOUNTNUMBER,
					orderSource: '',
					country: data.COUNTRY,
					tradingPartnerId:'',
					dateType:'SHIP',
					customerSiteId: SITEUSEID,
					requestedDeliveryDate: moment().format('MM/DD/YYYY'),
					state: STATE,
					zipCode: this.props.getZipCode(),
					warehouseCode : selectedADC || this.props.getZipCode(),
					shipMethod :'ADC Truckload',
					items: skuList
					};
			self.props.checkAvailabilityForOrder(payload, orderAvailability => {
				if (orderAvailability) {
					self.props.saveAvailabilityToCart({ responseObject: orderAvailability.map(orderAvailabilityItem => this.props.formatOrderAvailabilityData(orderAvailabilityItem)).concat(availabilityDataForAvailableBackorders) });
				}
			});
		}

	afterCart(response, self , selectedAccount, selectedPriceSource, cartItems){
		if(response.status && response.responseObject) {
			if(window.location.pathname.indexOf('cart') !== -1) {
				self.props.getPimDataForCartItem();
				const skuList = [];
				const servicesSkuList = [];
				response.responseObject && response.responseObject.cartItems && response.responseObject.cartItems.length > 0 && response.responseObject.cartItems.map((item, index) => {
					if(item.itemType === 'M' || item.itemType === 'A')
						skuList.push({"sku":item.item, demandClass: self.getDemadClassforAgreement(item.agreementNumber)})
					else {
						servicesSkuList.push({"sku":item.item})
					}
					return null;
				});
				const zipCode = self.props.getZipCode();
				zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
					if(resp && resp.agentid) {
						this.checkOrderAvailability();
						self.props.makeParallelCallsForCartPrices(response.responseObject.cartItems, true, true, 'cart', null, null);
						const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
						var servicesPayload = [];
						// fetch site id from SOLD_TO to address
						const soldToAddresses = self.props.getAddressesByCategory('SOLD_TO');
						let state = 'NA';
						let whse = 'NA';
						let zone = 'NA';
						if (soldToAddresses.length > 0) {
							state = soldToAddresses[0].STATE;
						}
						self.props.getShippingAddressesDetails(zipCode, false, 'sds_loc', resp => {
							if (resp) {
								whse = resp.agentid;
								zone = resp.sdsApZone;
								const { salesAgreementNumber, accountNumber } = checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
								servicesSkuList.length > 0 && servicesSkuList.map((item, index) => {
									return servicesPayload.push({
										pricingEffectiveDate: pricingEffectiveDate,
										accountNumber,
										state: state,
										zone: zone,
										whse: whse,
										salesAgreementNumber,
										itemNumber: item.sku
									});
								});
								servicesPayload.length > 0 && self.props.checkServicesPricesForCartPage({ items: servicesPayload }, `requestType=servicesPricing`);
							}
						});
					}
				});
			}
			response.responseObject.cartItems.map(item =>{
			cartItems.map(itm => {
						if(itm.item == item.item){
							item["overpackQuantityRequired"]=itm.overpackQuantityRequired;
							item["packageQuantity"]=itm.packageQuantity;
						}
				})
			})
			self.props.saveToCart(response);
		} else {
			browserHistory.push('/error');
		}
	}

	getDemadClassforAgreement(agreementNumber) {
		const self = this;
		const { selectedPriceSource, selectedAccountsAllPriceSources } = self.props.state.user;
		let priceSourceDetails = JSON.parse(JSON.stringify(selectedPriceSource));
		if (agreementNumber) {
			priceSourceDetails = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER.toString() === agreementNumber.toString());
		}
		if (priceSourceDetails && priceSourceDetails["Demand Class"]) {
			return priceSourceDetails["Demand Class"];
		}
	}

    render() {
        const { cart } = this.props.state.cart;
        const cartItems = cart && cart.responseObject && cart.responseObject.cartItems?cart.responseObject.cartItems:null;
        let skuList = cartItems && cartItems.map(item => {
			return item.item;
		});
		skuList = skuList ? skuList : [];
		const itemContains = skuList.indexOf(this.props.item) !== -1 ? true : false;
        return (
            <div>
				{this.props.isTypeAhead
                	?<div className="specPageCustomerNetSpecial">
                		{skuList!==null
							?<div className="leftSide">
			                    {itemContains
									?<p className="inCartButtonParagraph cartButtonParagraph">
								        <button style={this.state.isSpecpage?{width: '54%'}:{width: '100%'}} className="inCartButton blockButton">In Cart</button>
							        </p>
									:<p className="cartButtonContainer addToCartButtonContainer">
								        <a className="addToCartButton blockButton" style={this.state.isSpecpage?{width: '45%'}:{width: '100%'}} onClick={this.handleAddToCart.bind(this, this.props.item, this.props.itemDescription, this.props.itemType)} href="">{this.props.linkText || "Add to Cart"}</a>
							        </p>
								}
			        		</div>
							:null
						}
                	</div>
                	:<div>
	                    {itemContains
							?<p className="addProductBtn"><span id={"cartItem_"+this.props.item}><button className={this.props.linkStyle ? "" : "inCartButton blockButton"}>In Cart</button></span></p>
							:<p className={`${this.props.customCSSClass} addProductBtn`}><span id={"cartItem_"+this.props.item}><a className={this.props.linkStyle ? "" : "addToCartButton blockButton"} href="" onClick={this.handleAddToCart.bind(this, this.props.item, this.props.itemDescription, this.props.itemType)}>{this.props.linkText || "Add to Cart"}</a></span></p>
						}
	                </div>
				}
        	</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	addToCart: (payload, callback) => dispatch(addToCart(payload, callback)),
	saveToCart: (data) => dispatch(saveToCart(data)),
	getOrderDetailsList: (queryStringParams, callback) => dispatch(getOrderDetailsList(queryStringParams, callback)),
	saveOrderDetailsList: (orderDetailsList) => dispatch(saveOrderDetailsList(orderDetailsList)),
	checkServicesPricesForCartPage: (payload, queryStringParams, callback) => dispatch(checkServicesPricesForCartPage(payload, queryStringParams, callback)),
	getSearchKeywordSuggestionList: (payload, callback) => dispatch(getSearchKeywordSuggestionList(payload, callback)),
	ajaxRequestInitiated: (data) => dispatch(ajaxRequestInitiated(data)),
	ajaxRequestCompleted: (data) => dispatch(ajaxRequestCompleted(data)),
	saveAvailabilityToCart: (data) => dispatch(saveAvailabilityToCart(data)),
});

AddToCart = connect(mapStateToProps, mapDispatchToProps)(AddToCart);
export default AddToCart;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/common/AddToCart.js